export const CONTENT_ROUTES = {
  notes: '/content/notes',
  noteDetail: '/content/notes/detail',
  articles: '/content/articles',
  articleDetail: '/content/articles/detail',
  podcasts: '/content/podcasts',
  podcastDetail: '/content/podcasts/detail',
  infographics: '/content/infographics',
  infographicDetail: '/content/infographics/detail',
  dailyQuestions: '/content/daily-questions',
  dailyQuestionDetail: '/content/daily-questions/detail',
};
